<div >
    <div class="edit-button-style section-title" (click)="editScrubberPoints()">
        <img alt="edit" src="/assets/img/edit-icon.svg"> Edit
    </div>
    
    <snl-side-panel panelType="close"  [headerName]="headerName" size="large" [(isOpen)]="openEditScrubberPoints">
        <div sidePanelContent class="scrubberPoints-side-panel largeSidepanelWidth ">
            <ng-container *ngIf="ediScrubberPointsVal === 'editScrubberPointsVal_1'">
                <div class="editScrubberPointsVal_1">
                    <div class="scrubberCurrentPool">
                        <p class="body-b1 ">Current scrubber points</p>
                        <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentScrubberPoint | negativeToBracket}}</p>
                    </div>
                    <ng-container *ngIf="scrubberPointDetails?.hasPreviousChange">
                        <div class="effective-date mt-24 datePickerPoolPoints" *ngIf="scrubberPointsEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                            (selectedDate)="selectedScrubberPointsDate($event)"
                            [min]="minSelectableDate"
                            [startMonthDate]="effectiveDate"
                            [setDefaultDate]="false"
                            title="Effective date of change"></snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input editScrubberPointsVal_1ReasonInput">
                            <snl-multi-line-input 
                                [label]="'Reason for change'" 
                                [maxLength]="maxLength"
                                [value]="scrubberPointsReason"
                                [isError]="isTextError"
                                (fieldValue)="scrubberPointsfieldValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                    <div class="change-pool-points">
                        <p class="section-title color-primaryDefault" (click)="changeScrubberPoints()">Change scrubber points</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="ediScrubberPointsVal === 'editScrubberPointsVal_2'">
                <div class="editScrubberPointsVal_2" 
                [ngClass]="isScrubberPointsInputError('newScrubberPoints') ? 'displayErrmsg' : ''">
                    <form [formGroup]="newScrubberPointForm" class="newScrubberPointForm noUpcomingScrubberPointForm noUpcomingPoolPointForm">
                        <div class="new-pool-input">
                            <snl-input [label]="'New scrubber points'"
                            [isError]="isScrubberPointsInputError('newScrubberPoints')"
                            [errorMessage]="getScrubberPointsInputErrorMessage('newScrubberPoints')"
                            [value]="newScrubberPointForm.value.newScrubberPoints"
                            formControlName="newScrubberPoints"
                            (focusout)="handleFocusOutScrubberPoints($event)"
                            >
                            </snl-input>
                        </div>
                    </form>
                    <div class="effective-date datePickerPoolPoints">
                        <snl-date-picker-dropdown datePickerType="date"
                        (selectedDate)="selectedNewScrubberPointsDate($event)"
                        [min]="minSelectableDate"
                        title="Effective date of change"></snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input">
                        <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLengths" [isError]="isTextError"
                            (fieldValue)="newScrubberPointsfieldValue($event)"></snl-multi-line-input>
                    </div>
                    <div class="single-line"></div>
                    <div class="scrubberCurrentPool">
                        <p class="body-b1">Current scrubber points</p>
                        <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentScrubberPoint | negativeToBracket}}</p>
                    </div>
                    <ng-container *ngIf="scrubberPointDetails?.hasPreviousChange">
                        <div class="currentEffDate">
                            <p class="body-b1">Effective date of change</p>
                            <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentEffectiveDate | date:'dd MMM yyyy' }}</p>

                        </div>
                        <div class="resonForChange">
                            <p class="body-b1">Reason for change</p>
                            <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentReason}}</p>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="ediScrubberPointsVal === 'editScrubberPointsVal_3'">
                <div class="editScrubberPointsVal_3"
                 [ngClass]="isScrubberPointsInputError('newScrubberPoints') ? 'displayErrmsg' : ''">
                    <div class="notificationWrap" *ngIf="showDiscardScrubberBanner">
                        <span class="notificationData body-b1">
                            <div>
                                 <figure>
                                    <img src="assets/img/infoBlue.svg" alt="information">
                                </figure>
                            </div>
                           <div>
                             <span class="notificationData_text">To change the current details, you need 
                                to discard the upcoming change first.</span>
                           </div>
                           
                        </span>
                    </div>
                
                    <div class="scrubberCurrentPool notificationDataCurrentPool">
                        <p class="body-b1">Current scrubber points</p>
                        <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentScrubberPoint | negativeToBracket}}</p>
                    </div>
                    <ng-container *ngIf="scrubberPointDetails?.hasPreviousChange">
                        <div class="currentEffDate">
                            <p class="body-b1 ">Effective date of change</p>
                            <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentEffectiveDate | date:'dd MMM yyyy' }}</p>
                        </div>
                        <div class="resonForChange">
                            <p class="body-b1 ">Reason for change</p>
                            <p class="section-title fleet-section-title">{{scrubberPointDetails?.currentReason}} </p>
                        </div>
                    </ng-container>
                    <div class="single-line"></div>

                    <div class="upcomming-change ">
                        <div class="section-title fleet-body-b3 upCommingChange">Upcoming change</div>
                        <div class="discardWrap" >
                            <figure (click)="discardScrubberPoint()">
                                <img src="assets/img/delBlue.svg" alt="information">
                            </figure>                     
                            <span class="discardText section-title" (click)="discardScrubberPoint()">Discard</span>
                        </div>
                    </div>
                    <form [formGroup]="newScrubberPointForm" class="newScrubberPointForm upcomingPoolPointForm">
                        <div class="new-pool-input">
                            <snl-input [label]="'New scrubber points'"
                            [isError]="isScrubberPointsInputError('newScrubberPoints')"
                            [errorMessage]="getScrubberPointsInputErrorMessage('newScrubberPoints')"
                            [value]="newScrubberPointForm.value.newScrubberPoints"
                            formControlName="newScrubberPoints"></snl-input>
                        </div>
                    </form>
                    <div class="effective-date datePickerUpcomingPoolPoints" *ngIf="upcomingScrubberEffectiveDate as effectiveDate">
                        <snl-date-picker-dropdown datePickerType="date"
                        (selectedDate)="upComingScrubberPointsDate($event)"
                        [min]="minSelectableDate"
                        [startMonthDate]="effectiveDate"
                        [setDefaultDate]="false"
                            title="Effective date of change">
                        </snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input upComingReasonInput">
                        <snl-multi-line-input 
                            [label]="'Reason for change'"
                            [maxLength]="maxLengths"
                            [value]="upcomingScrubberReasonValue"
                            [isError]="isTextError"
                            (fieldValue)="upComingScrubberfieldValue($event)">
                        </snl-multi-line-input>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="ediScrubberPointsVal === 'editScrubberPointsVal_4' && openEditScrubberPoints">
                <div class="editScrubberPointsVal_4" 
                [ngClass]="isScrubberPointsInputError('pendingCalcScrubberPoints') ? 'displayErrmsg' : ''">
                   <div class="notificationWrap">
                        <span class="notificationData body-b1">
                            <figure>
                                <img src="assets/img/infoBlue.svg" alt="information">
                            </figure>
                            <span class="notificationData_text">
                                You can modify the details until <span class="dateScrubber body-b1 fw-700">{{scrubberPointDetails?.nextCalculationDate | date: 'dd MMM yyyy'}}</span>  without affecting distrubtion.
                            </span>
                        </span>
                    </div>
                    <form [formGroup]="newScrubberPointForm" class="pendingPoolPointForm ">
                        <div class="new-pool-input">
                            <snl-input [label]="'Current scrubber points'"
                                [isError]="isScrubberPointsInputError('pendingCalcScrubberPoints')"
                                [errorMessage]="getScrubberPointsInputErrorMessage('pendingCalcScrubberPoints')"
                                [value]="newScrubberPointForm.value.pendingCalcScrubberPoints"
                                formControlName="pendingCalcScrubberPoints" (focusout)="handleFocusOutScrubberPointsPending($event)">
                            </snl-input>
                        </div>
                    </form>
                    <ng-container *ngIf="scrubberPointDetails?.hasPreviousChange">  
                        <div class="effective-date datePickerPoolPoints" *ngIf="pendingScrubberEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                                [min]="minSelectableDate"
                                [startMonthDate]="effectiveDate"
                                [setDefaultDate]="false"
                                (selectedDate)="selectedPendingScrubberPointsDate($event)"
                                title="Effective date of change">
                            </snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input">
                            <snl-multi-line-input 
                                [label]="'Reason for change'" 
                                [maxLength]="maxLengths"
                                [value]="pendingCalcScrubberReason"
                                [isError]="isTextError"
                                (fieldValue)="pendingScrubberfieldValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                    <div class="single-line"></div>
                    <div class="scrubberCurrentPool previousPool">
                        <p class="body-b1 previousPoolPointText ">Previous scrubber points</p>
                        <span class="wrapRestore" (click)="revertScrubberPoints()">
                            <figure>
                                <img src="assets/img/arrowLeftIcon.svg" alt="arrowLeftIcon">
                            </figure>     
                            <span class="restoreText section-title fw-700">Restore previous</span>  
                        </span>
                        <p class="section-title fleet-section-title">{{scrubberPointDetails?.previousScrubberPoint | negativeToBracket}}</p>
                    </div>
                    <div class="currentEffDate">
                        <p class="body-b1 ">Effective date of change</p>
                        <p class="section-title fleet-section-title">{{scrubberPointDetails?.previousEffectiveDate  | date:'dd MMM yyyy'}}</p>
                    </div>
                    <div class="resonForChange">
                        <p class="body-b1">Reason for change</p>
                        <p class="section-title fleet-section-title">{{scrubberPointDetails?.previousReason}}</p>
                    </div>
                </div>
            </ng-container>
        </div>
        <div sidePanelFooterContent>
               <ng-container *ngIf="scrubberPointDetails?.hasPreviousChange">
                <snl-button *ngIf="scrubberPointDetails?.status === 'pendingCalculation'" type="primary" size="large"
                    (click)="openEditScrubberPoints = false;updateScrubberPoints()"
                    [disabled]="pendingCalcScrubberReasonError 
                    || !pendingCalcScrubberReason 
                    || !pendingCalcScrubberDate || !pendingCalcScrubberPointVal?.pendingCalcScrubberPoints">
                    Save and update
                </snl-button> 
                <snl-button class="noChange" *ngIf="scrubberPointDetails?.status === 'noChange' " type="primary" size="large"
                 (click)="openEditScrubberPoints = false;updateScrubberPoints()" 
                    [disabled]="
                    !newScrubberPointVal?.newScrubberPoints || 
                    !selectedNewScrubberPointsDateVal ||
                    !scrubberPointsNewReason || 
                    scrubberPointsNewReasonError
                    ">
                    Save and update
                </snl-button>  
                <snl-button   *ngIf="scrubberPointDetails?.status === 'upcomingChange'" type="primary" size="large"
                 (click)="openEditScrubberPoints = false;updateScrubberPoints()" 
                    [disabled]="!newScrubberPointVal?.newScrubberPoints || 
                    !upcomingScrubberEffectiveDate ||
                    !upcomingScrubberReasonValue || 
                    scrubberPointsNewReasonError"><!--  || !discardScrubberSuccess -->
                    Save and update
                </snl-button>
            </ng-container>
            <ng-container *ngIf="!scrubberPointDetails?.hasPreviousChange">
                <snl-button class="pending"  type="primary" size="large"
                 (click)="openEditScrubberPoints = false;updateScrubberPoints()" 
                    [disabled]="!newScrubberPointVal?.newScrubberPoints ||
                    !selectedNewScrubberPointsDateVal ||
                    !scrubberPointsNewReason ||
                    scrubberPointsNewReasonError">
                    Save and update
                </snl-button>
            </ng-container>
            <snl-button type="secondary" size="large" (click)="openEditScrubberPoints = false;closeSidePanel()">Cancel</snl-button>
        </div>
    </snl-side-panel>
</div>

<!-- ---discard scrubber point -->
<snl-modal (click)="openDiscardScrubberPoint = false" [type]="'small'" [open]="openDiscardScrubberPoint">
  <div slot="heading" class="ppLargeModalHeading"> Discard upcoming change </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="color__primary body-b1">
            You are about to cancel the scheduled scrubber points change, effective from 
            <span class="section-title">{{scrubberPointDetails?.upcomingEffectiveDate | date:'dd MMM yyyy'}}.</span>
            <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>      
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">      
      <snl-button type="primary" size="large" (click)="openDiscardScrubberPoint = false;discardScrubberPointChanges()">Discard</snl-button>
      <snl-button type="secondary" size="large" (click)="openDiscardScrubberPoint = false;cancelScrubberPoint()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>


<!-- ----revert scrubber -->
  <snl-modal (click)="openRestoreScrubberPoint = false" [type]="'small'" [open]="openRestoreScrubberPoint">
  <div slot="heading" class="ppLargeModalHeading"> Restore previous scrubber points </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="color__primary body-b1">
           You are about to change the current scrubber points back to the previous configuration. 
           <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openRestoreScrubberPoint = false;revertScrubberPointsChanges();">Restore</snl-button>      
      <snl-button type="secondary" size="large" (click)="openRestoreScrubberPoint = false;cancelScrubberPoint()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>